/**
 * Cadastros — Compatibilidade de equipamentos
 * Rota: /cadastros/compatibilidade-equipamentos
 */

import React from 'react';
import { HardDrive } from 'lucide-react';
import { IconSparkles } from '@tabler/icons-react';
import { openConfigOryaAssistant } from '../../config-assistant';
import '../../config-assistant/ConfigOryaAssistant.css';
import '../../equipe2/components/Equipe2View.css';
import VinculosPecasMock from './VinculosPecasMock';
import './CompatibilidadeEquipamentosPage.css';

export default function CompatibilidadeEquipamentosPage({ goPremium = false }) {
  return (
    <div className="equipe2-root ce-compat-root">
      <header className="equipe2-header">
        <div className="equipe2-header-row">
          <nav className="equipe2-breadcrumb" aria-label="Localização em cadastros">
            <span className="equipe2-breadcrumb-avatar" aria-hidden="true">C</span>
            <span className="equipe2-breadcrumb-segment equipe2-breadcrumb-segment--parent">Cadastros</span>
            <span className="equipe2-breadcrumb-sep" aria-hidden="true">/</span>
            <span className="equipe2-breadcrumb-current" aria-current="page">
              <HardDrive size={13} strokeWidth={1.75} aria-hidden className="equipe2-breadcrumb-current-icon" />
              <span className="equipe2-breadcrumb-current-text">Compatibilidade</span>
            </span>
          </nav>
          <button
            type="button"
            className="config-orya-nav-btn equipe2-orya-nav-btn"
            onClick={openConfigOryaAssistant}
            aria-label="Pergunte a IA"
          >
            <IconSparkles size={15} stroke={1.75} aria-hidden />
            <span className="config-orya-nav-btn-label">Pergunte a IA</span>
          </button>
        </div>
      </header>
      <div className="ce-compat-body">
        <VinculosPecasMock goPremium={goPremium} />
      </div>
    </div>
  );
}
